<template>
    <CModal
      :title="title"
      :color="color"
      size="lg"
      :show.sync="questionModal"
    >   
        <CForm>
            <CRow>
              <CCol :md="form.type != 'content' ? 3 : 12">
                <CSelect
                    label="Tipo"
                    id="type"
                    name="type"
                    :value.sync="$v.form.type.$model"
                    :options="typeOptions"
                  />
              </CCol>
              <CCol md="9" v-if="form.type != 'content'">
                <CInput
                  label="Pregunta:"
                  :lazy="false"
                  :value.sync="$v.form.name.$model"
                  :isValid="checkIfValid('name')"
                  placeholder=""
                  autocomplete="given-name"
                  invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres."
                />
              </CCol>
            </CRow>
            <CRow v-if="form.type != 'content'">
              <CCol md="9">
                <CInput
                  label="Descripción:"
                  :lazy="false"
                  :value.sync="$v.form.description.$model"
                  placeholder=""
                />
              </CCol>
              <CCol md="3">
                <CSelect
                    label="Requerido"
                    id="required"
                    name="required"
                    :value.sync="$v.form.required.$model"
                    :options="[{label: 'SI', value: '1'}, {label: 'NO', value: '0'}]"
                  />
              </CCol>
            </CRow>
            <CRow v-if="form.type != 'content'">
              <CCol md="4">
                <label class="d-block">Variante de respuesta</label>
                <label v-if="form.type != 'permission'"><input type="checkbox" v-model="form.allow_not_applicable"> Permitir "No aplica"</label>
                <span v-else>Respuestas fijas: SI / NO</span>
              </CCol>
              <CCol md="8" v-if="form.allow_not_applicable">
                <CInput label="Texto del checkbox:" v-model="form.not_applicable_label" placeholder="Ej. No aplica porque soy extranjero" />
              </CCol>
            </CRow>
            <CRow v-if="form.type == 'options' || form.type == 'multiple'">
              <CCol md="12">
                <CInput
                  label="Opciones (separadas por comas):"
                  :lazy="false"
                  :value.sync="$v.form.options.$model"
                  placeholder=""
                />
              </CCol>
            </CRow>
            <CRow v-if="form.type == 'permission'">
              <CCol md="12">
                <CInput label="Link de autorización" :value.sync="form.permission_link" placeholder="https://..." />
              </CCol>
              <CCol md="12">
                <CInput label="Título clickeable" :value.sync="form.permission_link_title" placeholder="Abrir autorización" />
              </CCol>
              <CCol md="12">
                <CInput label="Texto adicional" :value.sync="form.permission_instructions" placeholder="Instrucciones para llenar la autorización" />
              </CCol>
            </CRow>
            <CRow v-if="form.type != 'content'">
              <CCol md="6">
                <CSelect
                  label="Depende de pregunta previa"
                  :value.sync="form.dependency_question_id"
                  :options="dependencyQuestionOptions"
                />
              </CCol>
              <CCol md="6" v-if="form.dependency_question_id">
                <CInput
                  label="Respuesta para mostrar"
                  :lazy="false"
                  :value.sync="form.dependency_answer"
                  placeholder="Ej. SI"
                />
              </CCol>
            </CRow>
            <CRow v-if="form.type == 'content'">
              <CCol md="12">
                <div style="padding-bottom: 10px;">Contenido:<br /></div>
                <vue-editor v-model="form.content" :editor-toolbar="customToolbar" />
                <br />
              </CCol>
            </CRow>
        </CForm>
        <template #footer>
          <CButton @click="closeModal" color="secondary">Cancelar</CButton>
          <CButton @click="store" :color="color">Aceptar</CButton>
        </template>
    </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required, minLength, email, sameAs, helpers } from "vuelidate/lib/validators"

export default {
  name: 'QuestionModal',
  props: {
    permissions: Array,
    questions: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      questionModal: false,
      title: "Nueva Pregunta",
      color: "info",
      isEdit: false,
      form: {
          id: 0,
          travel_id: 0,
          code: '',
          name: '',
          type: 'text',
          description: '',
          options: '',
          required: '1',
          allow_not_applicable: false,
          not_applicable_label: '',
          dependency_question_id: '',
          dependency_answer: '',
          special: 0
      },
      submitted: false,
      fields: [
        {key: 'name', label: 'Pregunta'},
        {key: 'actions', label: '', class: 'actions' }
      ],
      typeOptions: [{label: "Texto", value: "text"}, {label: "Numérico", value: "number"}, {label: "Opciones", value: "options"}, {label: "Permiso", value: "permission"}, {label: "Selección múltiple", value: "multiple"}, {label: "Fecha", value: "date"}, {label: "Archivo", value: "file"}, {label: "Contenido", value: "content"}],
      special: 0,
      is_main: 1,
      customToolbar: [
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ["link", "image", "video"],
        ["clean"] // remove formatting button
      ],
    }
  },
  mounted: async function() {
    this.form = {
          id: 0,
          travel_id: 0,
          code: '',
          name: '',
          type: 'text',
          description: '',
          content: '',
          options: '',
          required: '1',
          allow_not_applicable: false,
          not_applicable_label: '',
        dependency_question_id: '',
        dependency_answer: '',
            permission_link: '',
            permission_link_title: '',
            permission_instructions: '',
          permission_link: '',
          permission_link_title: '',
          permission_instructions: '',
          special: 0
      }
  },
  methods: {
    storeModal (travel, is_main, special) {
      this.questionModal = true;
      this.color = "info";
      this.title = 'Nueva Pregunta';
      this.isEdit = false;
      this.submitted = false;
      this.special = special;

      this.is_main = is_main;

      if(!this.is_main){
        this.special = 1;
        this.title = 'Nueva Pregunta';
      }

      this.form = {
          id: 0,
          travel_id: travel.id,
          travel_form_id: travel.form.id !== undefined ? travel.form.id : 0,
          code: '',
          name: '',
          type: 'text',
          description: '',
          options: '',
          required: '1',
          allow_not_applicable: false,
          not_applicable_label: '',
          dependency_question_id: '',
          dependency_answer: '',
            permission_link: '',
            permission_link_title: '',
            permission_instructions: '',
          special: this.special
      }
    },
    updateModal (special, item) {
      this.questionModal = true;
      this.color = "warning";
      this.title = 'Editar Pregunta';
      this.isEdit = true;
      this.submitted = false;

      this.special = special;

      this.form = {
          id: item.id,
          travel_id: item.travel_id,
          code: item.code,
          name: item.question,
          type: item.type,
          description: item.description,
          options: item.options,
          required: item.required+"",
          allow_not_applicable: item.allow_not_applicable == 1,
          not_applicable_label: item.not_applicable_label || '',
          dependency_question_id: item.dependency_question_id ? (item.dependency_question_id + '') : '',
          dependency_answer: item.dependency_answer || '',
            permission_link: item.permission_link || '',
            permission_link_title: item.permission_link_title || '',
            permission_instructions: item.permission_instructions || '',
          special: item.is_special
      };
    },
    store () {
      this.$v.$touch();

      if(!this.form.dependency_question_id){
        this.form.dependency_answer = ''
      }

      if(this.form.type == 'permission'){
        this.form.options = 'SI,NO'
        this.form.allow_not_applicable = false
        this.form.not_applicable_label = ''
      }
      else{
        this.form.permission_link = ''
        this.form.permission_link_title = ''
        this.form.permission_instructions = ''
      }

      if (this.isValid) {
        this.submitted = true;

        if(this.form.id > 0){
          this.$emit("update", this.form );
        }
        else{
          this.$emit("store", this.form );
        }

        this.closeModal();
      }
    },
    closeModal () {
      this.questionModal = false;

      this.submitted = false
      this.$v.$reset()
    },
    checkIfValid (fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      
      return !(field.$invalid || field.$model === '')
    },
  },
  computed: {
    formString () { return JSON.stringify(this.form, null, 4) },
    isValid () {
      return !this.$v.form.$invalid
        && (!this.form.allow_not_applicable || this.form.not_applicable_label.trim().length > 0)
        && (!this.form.dependency_question_id || (this.form.dependency_answer || '').trim().length > 0)
        && (this.form.type != 'permission' || (
          (this.form.permission_link || '').trim().length > 0
          && (this.form.permission_link_title || '').trim().length > 0
          && (this.form.permission_instructions || '').trim().length > 0
        ))
    },
    isDirty () { return this.$v.form.$anyDirty },
    dependencyQuestionOptions () {
      const options = [{ label: 'Ninguna', value: '' }]
      this.questions
        .filter(question => ['options', 'permission'].includes(question.type) && question.id !== this.form.id)
        .forEach(question => {
          options.push({ label: question.question, value: question.id + '' })
        })

      return options
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      travel_id: { },
      name: {},
      type: { },
      description: { },
      options: { },
      required: { },
      allow_not_applicable: { },
      not_applicable_label: { }
    }
  }
}
</script>